// 扩展vue原有的功能：全局組件，自定义指令，挂载原型方法，註意：没有全局过滤器。
// 这就是插件
// vue2.0插件写法要素：导出一个對象，有install函數，默认传入了Vue构造函數，Vue基础之上扩展
// vue3.0插件写法要素：导出一个對象，有install函數，默认传入了app应用实例，app基础之上扩展

import defaultImg from '@/assets/images/200.png'
import Message from './Message'
import Confirm from './Confirm'
import Alert from './Alert'
import moment from 'moment-timezone'


// import XtxSkeleton from './xtx-skeleton.vue'
// import XtxCarousel from './xtx-carousel.vue'
// import XtxMore from './xtx-more.vue'
// import XtxBread from './xtx-bread.vue'
// import XtxBreadItem from './xtx-bread-item.vue'

// 使用 `require` 提供的函數 `context`  加载某一个目录下的所有 `.vue` 后缀的文件。
// 然后 `context` 函數会返回一个导入函數 `importFn`
// - 它又一个属性 `keys() `  获取所有的文件路径
// 通过文件路径數組，通过遍历數組，再使用 `importFn`  根據路径导入組件對象
// 遍历的同時进行全局註册即可

// context(目录路径，是否加载子目录，加载文件的匹配正则)
const importFn = require.context('./', false, /\.vue$/)

// 定义指令
const defineDirective = (app) => {
  // 1. 图片懒加载指令 v-lazy
  // 原理：先存储图片地址不能在src上，当图片进入可视区，将你存储图片地址设置给图片元素即可。
  app.directive('lazy', {
    // vue2.0 监听使用指令的DOM是否创建好，钩子函數：inserted
    // vue3.0 的指令拥有的钩子函數和組件的一样，使用指令的DOM是否创建好，钩子函數：mounted
    mounted(el, binding) {
      // 2. 创建一个观察對象，来观察当前使用指令的元素
      const observe = new IntersectionObserver(([{ isIntersecting }]) => {
        if (isIntersecting) {
          // 停止观察
          observe.unobserve(el)
          // 3. 把指令的值设置给el的src属性 binding.value就是指令的值
          // 4. 处理图片加载失败 error 图片加载失败的事件 load 图片加载成功
          el.onerror = () => {
            // 加载失败，设置默认图
            el.src = defaultImg
          }
          el.src = binding.value
        }
      }, {
          threshold: 0
        })
      // 开启观察
      observe.observe(el)
    }
  })
}

export default {
  install(app) {
    // 在app上进行扩展，app提供 component directive 函數
    // 如果要挂载原型 app.config.globalProperties 方式
    // app.component(XtxSkeleton.name, XtxSkeleton)
    // app.component(XtxCarousel.name, XtxCarousel)
    // app.component(XtxMore.name, XtxMore)
    // app.component(XtxBread.name, XtxBread)
    // app.component(XtxBreadItem.name, XtxBreadItem)

    // 根據keys批量註册
    importFn.keys().forEach(path => {
      // 导入組件
      const component = importFn(path).default
      // 进行註册
      app.component(component.name, component)
    })
    // 定义指令
    defineDirective(app)
    // 定义一个原型函數
    app.config.globalProperties.$message = Message
    app.config.globalProperties.$confirm = Confirm
    app.config.globalProperties.$alert = Alert
    app.config.globalProperties.$moment = moment.tz.setDefault("Asia/Shanghai")
  }
}
